import { render } from "./paired-comparison-v1.vue?vue&type=template&id=b4443cda"
import script from "./paired-comparison-v1.vue?vue&type=script&lang=js"
export * from "./paired-comparison-v1.vue?vue&type=script&lang=js"

import "./paired-comparison-v1.vue?vue&type=style&index=0&id=b4443cda&lang=sass"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__